import React from 'react';
import { Grid, TextField, InputAdornment } from '@mui/material';

// Shared two-field input for room square footage + ceiling height. Used
// by CreateRoomDialog, EditRoomDialog, and EstimateBuilder's inline add-
// room dialog. Keeping one source of truth means placeholder, step,
// helper text, and units only have to be tuned in one place.
const RoomDimensionsFields = ({
  squareFootage,
  onSquareFootageChange,
  ceilingHeight,
  onCeilingHeightChange,
  spacing = 2,
  sx,
}) => (
  <Grid container spacing={spacing} sx={sx}>
    <Grid item xs={6}>
      <TextField
        margin="dense"
        label="Square Footage"
        fullWidth
        variant="outlined"
        type="number"
        inputProps={{ min: 0, step: '0.01' }}
        value={squareFootage ?? ''}
        onChange={(e) => onSquareFootageChange(e.target.value)}
        placeholder="e.g., 180"
        InputProps={{ endAdornment: <InputAdornment position="end">sq ft</InputAdornment> }}
        helperText="Optional"
      />
    </Grid>
    <Grid item xs={6}>
      <TextField
        margin="dense"
        label="Ceiling Height"
        fullWidth
        variant="outlined"
        type="number"
        inputProps={{ min: 0, step: '0.1' }}
        value={ceilingHeight ?? ''}
        onChange={(e) => onCeilingHeightChange(e.target.value)}
        placeholder="e.g., 9"
        InputProps={{ endAdornment: <InputAdornment position="end">ft</InputAdornment> }}
        helperText="Optional"
      />
    </Grid>
  </Grid>
);

export default RoomDimensionsFields;
